import { useAnchorClickMessageDispatcher } from '@carvana/merch-native';
import { isNonProd } from '~/constants/environment';
import useUpdateGeolocationDispatcher from '~/native/common/dispatchers/useUpdateGeolocationDispatcher';
import { logError } from '~/utilities/loggers';
import {
  useAppliedFiltersDispatcher,
  useModalMessageDispatcher,
  usePageReadyDispatcher,
  useTradeInAppliedDispatcher
} from './dispatchers';
import { source } from './dispatchers/constants';
import useFullscreenDispatcher from './dispatchers/useFullscreenDispatcher';

export default function useNativeMessageDispatcher() {
  useAnchorClickMessageDispatcher({
    logError,
    source,
    verboseLogs: isNonProd
  });
  useAppliedFiltersDispatcher();
  useFullscreenDispatcher();
  useModalMessageDispatcher();
  usePageReadyDispatcher();
  useTradeInAppliedDispatcher();
  useUpdateGeolocationDispatcher();
}
